import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const TooltipContainer = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: ${customPalette.accent.defaultGreen};
  border-radius: 50%;
  color: ${customPalette.accent.white};

  & > svg {
    font-size: 16px;
  }
`;

export const tooltipStyles = {
  tooltip: {
    bgcolor: customPalette.accent.main,
    color: customPalette.accent.white,
    padding: '12px 24px',
    borderRadius: '16px',
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: '19px',
  },
};

export const getMarginStyles = (placement?: string) => ({
  marginLeft: placement?.includes('right') ? '8px' : 0,
  marginRight: placement?.includes('left') ? '8px' : 0,
  marginTop: placement?.includes('bottom') ? '8px' : 0,
  marginBottom: placement?.includes('top') ? '8px' : 0,
});
